import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { onAudioProblem } from '@/lib/wordAudio';

/**
 * Полоска «звук недоступен».
 *
 * ⚠️ ЗАЧЕМ. Когда синтез речи отваливается (кончились деньги у поставщика,
 * упала сеть), кнопка нажимается, а звука нет. Раньше в этот момент не
 * происходило РОВНО НИЧЕГО: человек решал, что сломался телефон, и жал ещё раз.
 * Теперь он видит короткое объяснение (задача 122).
 *
 * Полоска общая на всё приложение: звук зовут из словаря, из урока, из слова
 * дня и от ИИ-собеседника, и в каждом месте своё сообщение — это четыре разных
 * куска кода, которые разъедутся. Здесь один.
 */
export function AudioNotice() {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    const off = onAudioProblem(() => {
      setShown(true);
      // Повторное нажатие продлевает показ, а не плодит вторую полоску.
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => setShown(false), 5000);
    });
    return () => {
      off();
      if (timer) clearTimeout(timer);
    };
  }, []);

  if (!shown) return null;
  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 bottom-24 z-50 flex justify-center px-4 md:bottom-8"
    >
      <span className="flex items-center gap-2 rounded-pill bg-surface-container-highest px-4 py-2 text-sm font-medium text-on-surface shadow-lg">
        <span className="material-symbols-outlined text-base">volume_off</span>
        {t('audio.unavailable')}
      </span>
    </div>
  );
}
